let Sortable = require('sortablejs');
window.Sortable = Sortable;

require('jquery-sortablejs');

const SortableHook = {
  mounted() {
    let that = this;
    const key = this.el.dataset.sortableKey;
    const target = this.el.dataset.target;

    let opts = {
      animation: 150,
      ghostClass: 'sortable-ghost',
      onUpdate: function () {
        let data = this.toArray().map((id) => {
          return parseInt(id);
        });

        const payload = { data: data, key: key };

        if (!!target) {
          that.pushEventTo(target, 'sort', payload);
        } else {
          that.pushEvent('sort', payload);
        }
      },
    };

    if (!!this.el.dataset.handle) {
      opts.handle = this.el.dataset.halde;
    }

    $(this.el).sortable(opts);
  },
};

export default SortableHook;
